/**
 * Builds a mailto URL with optional subject and body
 * Properly encodes all parameters to handle spaces, special characters, and newlines
 * @param email - The email address
 * @param subject - Optional email subject
 * @param body - Optional email body
 * @returns Complete mailto URL with properly encoded parameters
 */
export const buildMailtoUrl = (email: string, subject?: string, body?: string): string => {
  const urlParts: string[] = [`mailto:${encodeURIComponent(email.trim())}`];
  const params: string[] = [];

  // Add subject if provided
  if (subject && subject.trim()) {
    params.push(`subject=${encodeURIComponent(subject.trim())}`);
  }

  // Add body if provided
  if (body && body.trim()) {
    params.push(`body=${encodeURIComponent(body.trim())}`);
  }

  // Join parameters with & and add to URL if any exist
  if (params.length > 0) {
    urlParts.push('?');
    urlParts.push(params.join('&'));
  }

  return urlParts.join('');
};
